module.exports = __webpack_public_path__ + "img/mayologobg2.10a459ae.png";